import { render } from "./StoreChainFormView.vue?vue&type=template&id=97e728d0&scoped=true"
import script from "./StoreChainFormView.vue?vue&type=script&lang=js"
export * from "./StoreChainFormView.vue?vue&type=script&lang=js"

import "./StoreChainFormView.vue?vue&type=style&index=0&id=97e728d0&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e728d0"]])

export default __exports__